module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/storage-unit-5x5.webp";